// src/pages/campaign/WizardIntroPage.jsx

import { motion } from "framer-motion";
import {
  ArrowLeft,
  ArrowRight,
  Brain,
  Dumbbell,
  HeartPulse,
  Sparkles,
  Target,
  Utensils,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
export default function WizardIntroPage() {
    const navigate = useNavigate();
  return (
    <main
      dir="rtl"
      className="font-vazir relative min-h-screen overflow-hidden bg-[#030712] text-white"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(16,185,129,.3),transparent_35%),radial-gradient(circle_at_0%_100%,rgba(37,99,235,.25),transparent_40%)]" />

      <div className="absolute inset-0 opacity-[.15] bg-[linear-gradient(rgba(255,255,255,.08)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.08)_1px,transparent_1px)] bg-[size:34px_34px]" />

      <section className="relative z-10 mx-auto flex min-h-screen max-w-md flex-col px-5 py-6">

        <motion.div
          initial={{ opacity: 0, scale: .92 }}
          animate={{ opacity: 1, scale: 1 }}
          className="mt-8 flex justify-center"
        >
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-emerald-400/20 blur-3xl" />

            <div className="relative grid h-28 w-28 place-items-center rounded-full border border-emerald-300/20 bg-black/30 backdrop-blur-xl">
              <Brain
                size={46}
                className="text-emerald-300"
              />
            </div>
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-8 text-center text-2xl font-black leading-tight"
        >
          آماده‌ای تحلیل رو شروع کنیم؟
        </motion.h1>

        <p className="mt-4 text-center text-sm leading-7 text-white/55">
          فقط چند سوال کوتاه ازت می‌پرسیم تا هوش مصنوعی موجیم بتونه
          شرایط بدنی و هدفت رو تحلیل کنه.
        </p>

        <div className="mt-8 space-y-3">
          <Feature
            icon={Target}
            title="هدف تمرینی"
            desc="چربی سوزی، عضله سازی یا تناسب اندام"
          />

          <Feature
            icon={Dumbbell}
            title="محل تمرین"
            desc="باشگاه یا خانه"
          />

          <Feature
            icon={HeartPulse}
            title="شرایط بدنی"
            desc="وزن، قد و محدودیت‌های احتمالی"
          />

          <Feature
            icon={Utensils}
            title="رژیم غذایی"
            desc="برای شخصی‌سازی بهتر برنامه"
          />
        </div>


        <div className="mt-auto pt-8">
          <button
onClick={() => navigate("/body-analysis/wizard")}
            className="
              flex
              h-16
              w-full
              items-center
              justify-center
              gap-2
              rounded-3xl
              bg-gradient-to-r
              from-emerald-300
              via-green-400
              to-cyan-400
              font-black
              text-black
              shadow-[0_0_80px_rgba(52,211,153,.5)]
            "
          >
                        <ArrowRight size={20} />

            شروع تحلیل
          </button>

          <div className="mt-4 text-center text-[11px] text-white/45">
            کمتر از ۲ دقیقه زمان می‌برد
          </div>
        </div>
      </section>
    </main>
  );
}

function Feature({ icon: Icon, title, desc }) {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="
        flex
        items-center
        gap-3
        rounded-3xl
        border
        border-white/10
        bg-white/[.04]
        p-4
        backdrop-blur-xl
      "
    >
      <div className="grid h-12 w-12 place-items-center rounded-2xl bg-emerald-400/10 text-emerald-300">
        <Icon size={22} />
      </div>

      <div>
        <div className="font-bold">
          {title}
        </div>

        <div className="mt-1 text-xs text-white/55">
          {desc}
        </div>
      </div>
    </motion.div>
  );
}